export default __webpack_public_path__ + "static/media/img_02.b0bae79e.jpg";